'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var truncateOptionsShape = _react.PropTypes.shape({
  desiredLength: _react.PropTypes.number,
  softTruncate: _react.PropTypes.bool,
  showEllipsis: _react.PropTypes.bool
});

exports.default = truncateOptionsShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/truncateOptionsShape.js
// module id = 1384
// module chunks = 1